


























































import { Component, Prop, PropSync, Ref, Vue } from "vue-property-decorator";
import { downloadUrl } from "@root/utiles/common.ts";
import { loading, loadingCatch } from "@root/lib/decorator";

const defaultOptions = () => ({
  accept: "",
  tip: "", // 上传提示
  btnText: "选取文件",
  downloadText: "下载模板",
  confirmText: "导入",
  limit: 2, // FIXME: hack方法，默认会覆盖，只保留一个文件
  multiple: false,
  showDownload: true // 显示下载
});

@Component
@loading()
export default class GtImportDialog extends Vue {
  @PropSync("visible", { default: false, type: Boolean }) visibleSync: Boolean;
  @Prop({ type: Object, default: () => defaultOptions() }) options: any;
  @Prop({ type: Function, default: () => {} }) uploadMethod: Function;
  @Prop({ type: Function }) beforeUpload: Function;

  @Ref("upload") uploadRef: any;

  private fileList: any[] = [];
  private downloadTemplateCache: string = "";

  get finalOptions() {
    return {
      ...defaultOptions(),
      ...this.options
    };
  }

  onChange(file, fileList) {
    if (fileList.length > 1) {
      fileList.shift();
    }
    this.fileList = fileList;
  }

  onRemove(file, fileList) {
    this.fileList = fileList;
  }

  @loadingCatch
  async manualUpload() {
    // 弃用（不支持 async await）
    // this.uploadRef.submit();
    if (this.beforeUpload && !(await this.beforeUpload(this.fileList))) {
      return false;
    }
    // 自定义上传的方法
    await this.uploadMethod(
      this.fileList.map(o => ({
        file: o.raw,
        ...o
      }))
    );
    // 清除文件
    this.clearFiles();
  }

  clearFiles() {
    this.uploadRef.clearFiles();
    this.fileList = [];
  }

  // download template
  async downloadClick(template) {
    if (!template) return;
    // cache download template
    if (this.downloadTemplateCache) {
      downloadUrl(this.downloadTemplateCache);
      return;
    }
    // Promise
    if (template instanceof Promise) {
      template = await template;
    }
    // Function
    if (template instanceof Function) {
      const url = await template();
      downloadUrl(url);
    }
    // String
    else if (typeof template === "string") {
      downloadUrl((this.downloadTemplateCache = template as string));
    }
  }
}
